<template>
  <div id="smpChart"></div>
</template>

<script>
  import c3 from 'c3'

  export default {
    name: 'smp-chart',
    props: {
      active: {
        type: Boolean,
        default: function () {
          return true
        }
      },
      value: {
        type: Object,
        default: function () {
          return {}
        }
      },
      type: {
        type: String,
        default: function () {
          return 'day'
        }
      }
    },
    watch: {
      'active': {
        handler: function (val) {
          this.$nextTick(() => {
            if (val) {
              this.init()
            }
          })
        }
      },
      'value': {
        handler: function () {
          if (this.active) {
            this.init()
          }
        },
        deep: true
      }
    },
    methods: {
      init: function () {
        // 현재 선택된 SMP 타입에 따라 차트를 그린다.
        if (this.type === 'day') {
          this.drawDayChart()
        } else {
          this.drawMonthChart()
        }
      },
      drawDayChart: function () {
        const vm = this
        const data = vm.value

        if (data) {
          // Chart Configuration
          const chartConfig = {
            bindto: '#smpChart',
            padding: {
              right: 16
            },
            data: {
              x: 'x',
              columns: [
                ['x'].concat(data.smp_land_period.map(x => x.slice(4, 6) + '.' + x.slice(6, 8))),
                ['육지'].concat(data.smp_land_price),
                ['제주'].concat(data.smp_jeju_price)
              ]
            },
            axis: {
              x: {
                type: 'category',
                label: {
                  text: '(월/일)',
                  position: 'inner-top'
                },
                tick: {
                  fit: true,
                  centered: true,
                  multiline: false,
                  format: function (d) {
                    return d % 4 === 0 ? data.smp_land_period.map(x => x.slice(4, 6) + '.' + x.slice(6, 8))[d] : ''
                  }
                },
                color: '#ffffff'
              },
              y: {
                label: {
                  text: '(원/kWh)',
                  position: 'inner-top'
                }
              }
            },
            point: {
              r: 0.7
            },
            legend: {
              // amount of padding to put between each legend element
              padding: 5,
              // define custom height and width for the legend item tile
              item: {
                tile: {
                  width: 15,
                  height: 2
                }
              }
            },
            grid: {
              y: {
                show: true
              }
            },
            color: {
              pattern: ['#00aeef', '#7a98b6']
            },
            tooltip: {
              format: {
                title: function (index) {
                  // YYYYMMDD => MM.DD 형태로 출력
                  const period = data.smp_land_period[index]

                  return period.slice(4, 6) + '.' + period.slice(6, 8)
                },
                value: function (value) {
                  const price = parseFloat(value).toFixed(2)
                  return price + '원'
                }
              }
            }
          }

          // Draw Chart
          c3.generate(chartConfig)
        }
      },
      drawMonthChart: function () {
        const vm = this
        const data = vm.value

        if (data) {
          // Chart Configuration
          const chartConfig = {
            bindto: '#smpChart',
            padding: {
              right: 16
            },
            data: {
              x: 'x',
              columns: [
                ['x'].concat(data.smp_land_period.map(x => x.slice(2, 4) + '.' + x.slice(4, 6))),
                ['육지'].concat(data.smp_land_price),
                ['제주'].concat(data.smp_jeju_price)
              ]
            },
            axis: {
              x: {
                type: 'category',
                label: {
                  text: '(년/월)',
                  position: 'inner-top'
                },
                tick: {
                  fit: true,
                  centered: true,
                  multiline: false,
                  format: function (d) {
                    return d % 2 === 0 ? data.smp_land_period.map(x => '\'' + x.slice(2, 4) + '/' + x.slice(4, 6))[d] : ''
                  }
                }
              },
              y: {
                label: {
                  text: '(원/kWh)',
                  position: 'inner-top'
                }
              }
            },
            point: {
              show: false
            },
            legend: {
              // amount of padding to put between each legend element
              padding: 5,
              // define custom height and width for the legend item tile
              item: {
                tile: {
                  width: 15,
                  height: 2
                }
              }
            },
            grid: {
              y: {
                show: true
              }
            },
            color: {
              pattern: ['#00aeef', '#7a98b6']
            },
            tooltip: {
              format: {
                title: function (index) {
                  // YYYYMM => YY/MM 형태로 출력
                  const period = data.smp_land_period[index]

                  return period.slice(2, 4) + '/' + period.slice(4, 6)
                },
                value: function (value) {
                  const price = parseFloat(value).toFixed(2)
                  return price + '원'
                }
              }
            }
          }

          // Draw Chart
          c3.generate(chartConfig)
        }
      }
    },
    mounted: function () {
      this.init()
    }
  }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/chart/SmpChart.vue